export const ReviewReasonOptions = {
  PriceChangeSuppression: "Price Change Suppression",
  ErroneousTransfer: "Erroneous Transfer",
  InvestigateMeteringIssue: "Investigate Metering Issue",
  DisputedReadSARSProcess: "Disputed Read (SARS) Process",
  CustomerDeceased: "Customer Deceased",
  DebtCollectionsAgency: "Debt Collections Agency",
  CustomerRequested: "Customer Requested",
  BillingIssue: "Billing Issue",
  InvestigateDataflowIssue: "Investigate Dataflow Issue",
  ChangeOfMode: "Change of Mode",
  SupplyLossDuringVariablePriceChangeProtectionPeriod:
    "Supply Loss During Variable Price Change Protection Period",
  BillingMPXNIssue: "Billing - MPXN Issue",
  SOOCRateSuppression: "SOOC Rate Suppression",
  ReVersionedBillInPaymentPlan: "Re-Versioned Bill In Payment Plan",
  SMETS1GainWakeUp: "SMETS1 Gain Wake Up",
  Other: "Other",
  OpsRegistrationsETs: "Ops Registrations - ET's",
  OpsRegistrationsCrossMetering: "Ops Registrations - Cross-metering",
  OpsRegistrations: "Ops Registrations",
  OpsDisputedReadings: "Ops Disputed Readings",
  OpsSettlements: "Ops Settlements",
  PaymentsPaymentPromise: "Payments - Payment Promise",
  PaymentsSuppressDirectDebitReview: "Payments - Suppress Direct Debit Review",
  Metering: "Metering",
  MeteringSmart: "Metering - Smart",
  COTDeceased: "COT Deceased",
  COTGeneral: "COT General (Moving out/In/ Update details etc)",
  OpsBillingSmartMeterReadingsIssue: "Ops Billing - Smart Meter Readings Issue",
  OpsBillingFailedBills: "Ops Billing - Failed Bills",
  OpsBilling: "Ops Billing",
} as const
